import { combineReducers } from "redux";
import cachedDataReducer from "./cachedDataReducer";
import fetchedSelectionsReducer from "./fetchedSelectionsReducer";
import filePreviewReducer from "./filePreviewReducer";
import loanDrilldownReducer from "./loanDrilldownReducer";
import loanPipelineReducer from "./loanPipelineReducer";
import navSidebarReducer from "./navSidebarReducer";
import pipelineReducer from "./pipelineReducer";
import sidebarReducer from "./sidebarReducer";
import userReducer from "./userReducer";
import usersReducer from "./usersReducer";
import workspaceTabsReducer from "./workspaceTabsReducer";
import loanFetchedDataReducer from "./loanFetchedDataReducer";
import modalReducer from "./modalReducer";

const rootReducer = combineReducers({
  cachedData: cachedDataReducer,
  user: userReducer,
  users: usersReducer,
  modal: modalReducer,
  navSidebar: navSidebarReducer,
  loanDrilldown: loanDrilldownReducer,
  sidebar: sidebarReducer,
  loanFetchedData: loanFetchedDataReducer,
  filePreview: filePreviewReducer,
  fetchedSelections: fetchedSelectionsReducer,
  loanPipeline: loanPipelineReducer,
  pipeline: pipelineReducer,
  workspaceTabs: workspaceTabsReducer,
});

export default rootReducer;
